
import Gutter from '@/ui-kit/components/gutter';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import { Comparator } from '@/ui-kit/enums';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StyleFontWeightType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import LazyImage from '@/components/lazy-image';
import SelectProvince from '@/components/inputs/province';
import ImageHelper from '@/utils/ImageHelper';
import UserSelectionStoreName from '@/store/user-selection/name';
import { PROVINCE_OPTIONS_NOT_ONTARIO } from '@/constants';

export default {
  name: 'SellerChecklistHero',
  components: {
    LazyImage,
    SelectProvince,
    Typography,
    Gutter,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      TypographyType,
      TypographyProperty,
      StyleColorSchemeType,
      StyleFontWeightType,
      StylePositionType,
      StyleSizeType,
      GutterProperty,
      PROVINCE_OPTIONS_NOT_ONTARIO,
    };
  },
  computed: {
    heroImageClassNames() {
      return new StyleClassNamesBuilder('seller-checklist-hero-section__side')
        .addClassName('seller-checklist-hero-section__side--background')
        .build();
    },
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.data.image.dimensions);
    },
    heroImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: StyleSizeType.XSmall,
          imageSize: 420,
        },
        {
          comparator: Comparator.Less,
          breakpoint: StyleSizeType.Small,
          imageSize: 600,
        },
        {
          comparator: Comparator.Less,
          breakpoint: StyleSizeType.Medium,
          imageSize: 800,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: StyleSizeType.Medium,
          imageSize: 600,
        },
      ];
    },
    currentProvince() {
      return this.$store.state[UserSelectionStoreName].currentProvince;
    },
  },
};
